import { useAuth0 } from '@auth0/auth0-react';
import { createContext, useContext, useMemo } from 'react';

import { ApiClient } from './client';

const ApiClientContext = createContext<ApiClient | null>(null);

interface ApiClientProviderProps {
  children: React.ReactNode;
}

export const ApiClientProvider = ({ children }: ApiClientProviderProps) => {
  const { getAccessTokenSilently } = useAuth0();
  const apiClient = useMemo(
    () => new ApiClient(getAccessTokenSilently),
    [getAccessTokenSilently]
  );

  return (
    <ApiClientContext.Provider value={apiClient}>
      {children}
    </ApiClientContext.Provider>
  );
};

export function useApiClient() {
  const apiClient = useContext(ApiClientContext);
  if (!apiClient) {
    throw new Error(
      "ApiClientContext doesn't have a value an api client set up. Make sure you wrap your app in an ApiClientProvider and provide apiClient."
    );
  }

  return apiClient;
}
